import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {ConstantService} from "../constant.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ReceiverService {
  private readonly HOST = this.remoteHost.remoteHost();
  private readonly URL = this.HOST + 'receiver/';
  private readonly URL_FULL = this.HOST + 'receiverFull/';


  constructor(public httpClient: HttpClient, public remoteHost: ConstantService) { }

  // 提取所有入库批次
  getReceiverList( client = '', page = 1, pageSize = 2000,): Observable<any> {

    const params = new HttpParams()
      .set('client', client.toString())
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    return this.httpClient.get<any>(this.URL, {params, headers: this.remoteHost.headersIncludeToken});
  }

  // 提取所有入库批次 含客户信息
  getReceiverFullList( client = '', page = 1, pageSize = 10000, ): Observable<any> {

    const params = new HttpParams()
      .set('client', client.toString())
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    return this.httpClient.get<any>(this.URL_FULL, {params, headers: this.remoteHost.headersIncludeToken});
  }

  // 提取指定批次信息 含客户信息
  getReceiverFullById(id: any ): Observable<any> {

    const params = new HttpParams()
      .set('id', id.toString());

    return this.httpClient.get<any>(this.URL_FULL + id + '/', {params, headers: this.remoteHost.headersIncludeToken});
  }

  // 添加 Receiver
  addReceiver(Receiver: any): Observable<any> {
    return this.httpClient.post<any>(this.URL, Receiver, {headers: this.remoteHost.headersIncludeToken});
  }
}
